'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
require('../../../components/Card/Card.js');
require('../../../components/Card/CardBody.js');
var CardFooter = require('../../../components/Card/CardFooter.js');
require('../../../components/Card/CardHeader.js');
require('../../../components/Card/CardHeaderAddon.js');
require('../../../components/Card/CardEditButton.js');
require('../../../components/Card/CardHeaderEditButton.js');
require('../../../components/Card/CardFooterEditButton.js');
require('../../../components/Card/CardEmpty.js');
var useEditCard = require('./useEditCard.js');
var EditCardCancelButton = require('./EditCardCancelButton.js');
var EditCardSubmitButton = require('./EditCardSubmitButton.js');
var EditCardHeaderEditButton = require('./EditCardHeaderEditButton.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Edit card footer
 *
 * Contains cancel and submit buttons as well as the edit button for the empty.
 */
var EditCardFooter = react.forwardRef(function (props, ref) {
  var _useEditCardContext = useEditCard.useEditCardContext(),
    isEditing = _useEditCardContext.isEditing,
    isEmpty = _useEditCardContext.isEmpty;
  var showEmptyFooter = isEmpty && !isEditing;
  var isVisible = !!isEditing || !!showEmptyFooter;
  var styles = showEmptyFooter && {
    borderTop: 'none',
    alignItems: 'center',
    justifyContent: 'center'
  };
  return /*#__PURE__*/React__default["default"].createElement(react.Collapse, {
    "in": isVisible
  }, /*#__PURE__*/React__default["default"].createElement(CardFooter.CardFooter, _extends__default["default"]({
    sx: styles
  }, props, {
    ref: ref
  }), showEmptyFooter ? /*#__PURE__*/React__default["default"].createElement(EditCardHeaderEditButton.EditCardFooterEditButton, null) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(EditCardCancelButton.EditCardCancelButton, null), /*#__PURE__*/React__default["default"].createElement(EditCardSubmitButton.EditCardSubmitButton, null))));
});
EditCardFooter.displayName = 'EditCardFooter';
exports.EditCardFooter = EditCardFooter;